import { extend } from 'vee-validate'
import {length, numeric} from 'vee-validate/dist/rules.js'
import { differenceInYears, parse, isAfter, isEqual } from 'date-fns'

extend('ua_letters_space_hyphen', {
  validate(value) {
    return /^[а-щьюяґєії \-'`ʼ’‘—–−]*$/gi.test(value)
  },
  message: 'validations.ua_letters_space_hyphen'
})


extend('ua_letters_space', {
  validate(value) {
    return /^[а-щьюяґєії '`ʼ‘’]*$/gi.test(value)
  },
  message: 'validations.ua_letters_space'
})

extend('bank_name', {
  validate(value) {
    return /^[0-9a-zа-щьюяґєіїa-z «»„“” ‹›〞〟"\-'`ʼ’‘]*$/gi.test(value.replace(/\u200E/g, ''))
  },
  message: 'validations.bank_name'
})

extend('identify_code', {
  validate(value) {
    return /^[0-9a-z]*$/gi.test(value)
  },
  message: 'validations.identify_code'
})
extend('ua_birth_place', {
  validate(value) {
    return /^[а-щьюяґєії \-.,'`ʼ’‘]*$/gi.test(value)
  },
  message: 'validations.ua_birth_place'
})

extend('ua_letters_space_numeric', {
  validate(value) {
    return /^[0-9а-щьюяґєії .'`ʼ’‘]*$/gi.test(value)
  },
  message: 'validations.ua_letters_space_numeric'
})

extend('ua_letters_space_numeric_dash', {
  validate(value) {
    return /^[0-9а-щьюяґєії .'`ʼ’‘—–−-]*$/gi.test(value)
  },
  message: 'validations.ua_letters_space_numeric_dash'
})

extend('street_name', {
  validate(value) {
    return /^[0-9а-щьюяґєії \-.,/'`‘’ʼ]*$/gi.test(value)
  },
  message: 'validations.street_name'
})
extend('ua_state_region', {
  validate(value) {
    return /^[а-щьюяґєії \-'`ʼ’‘]*$/gi.test(value)
  },
  message: 'validations.ua_state_region'
})

extend('ua_house', {
  validate(value) {
    return /^[0-9а-щьюяґєії \-.\/'`ʼ’‘]*$/gi.test(value)
  },
  message: 'validations.ua_house'
})

extend('ua_flat_number', {
  validate(value) {
    return /^[0-9а-щьюяґєії \-./'`ʼ’‘]*$/gi.test(value)
  },
  message: 'validations.ua_flat_number'
})

extend('iban', {
  validate(value) {
    return /^[A-Z]{2}\d{27}$/i.test(value)
  },
  message: 'validations.neres_iban'
})
extend('ua_passport_series', {
  validate(value) {
    return /^[а-щьюяґєіїa-z]*$/gi.test(value)
  },
  message: 'validations.ua_passport_series'
})

extend('ua_passport_series_latin', {
  validate(value) {
    return /^[a-z]*$/gi.test(value)
  },
  message: 'validations.ua_passport_series_latin'
})

extend('ua_passport_series_latin_number', {
  validate(value) {
    return /^[a-z0-9]*$/gi.test(value)
  },
  message: 'validations.ua_passport_series_latin_number'
})
extend('ua_registration_address', {
  validate(value) {
    return /^[0-9а-щьюяґєії ., «»„“”‹›〞〟"\-'`‘ʼ’()\/]*$/gi.test(value.replace(/\u200E/g, ''))
  },
  message: 'validations.ua_registration_address',
})

extend('eddr_number', {
  validate(value) {
    return !!value && /^\d{8}-\d{5}$/.test(value)
  },
  message: 'validations.eddr_number'
})
extend('ua_country', {
  validate(value) {
    return /^[а-щьюяґєії '`ʼ’‘]*$/i.test(value)
  },
  message: 'validations.ua_country'
})

extend('ua_card_expire', {
  validate(value) {
    return !value ||  /^((1[0-2])|(0[1-9]))\/((2[2-9])|([3-9][0-9]))$/gi.test(value)
  },
  message: 'validations.ua_card_expire'
})

extend('ua_valid_until', {
  validate(validUntil, {issuedDate}) {
    if (!validUntil) {
      return true
    }
    return new Date(validUntil) > new Date(issuedDate)
  },
  message: 'validations.ua_valid_until',
  params: ['issuedDate']
})

extend('valid_until_more_then_10', {
  validate(validUntil, {isPassportID, issuedDate}) {
    if (!validUntil || !isPassportID) {
      return true
    }
    const dateStart = parse(issuedDate, 'yyyy-MM-dd', new Date())
    const dateEnd = parse(validUntil, 'yyyy-MM-dd', new Date())
    const diff = differenceInYears(dateEnd, dateStart)
    return diff >= 10
  },
  message: 'validations.ua_valid_until',
  params: ['issuedDate', 'isPassportID']
})

extend('register_source', {
  validate(value) {
    if (!value) {
      return true
    }

    return /^[0-9а-щьюяґєіїa-z '`ʼ’‘\-,.]*$/i.test(value)
  },

  message: 'validations.register_source'
})

extend('full_age', {
  validate(value) {
    const date = parse(value, 'yyyy-MM-dd', new Date())
    const age = differenceInYears(new Date(), date)
   return age >= 18
  },
  message: 'validations.full_age'
})

extend('isCardUniq', {
  params: ['cards'],
  validate: (value, { cards }) => !value || !cards.includes(value),
  message:
      'validations.card_is_not_unique'
})

extend('isCorrectDateRange', {
  params: ['startDate'],
  validate: (value, { startDate }) => {
    const start=parse(startDate, 'yyyy-MM-dd', new Date())
    const end= parse(value, 'yyyy-MM-dd', new Date())
    return isAfter(end, start) || isEqual(end, start)
  },
  message:
    'validations.date-range-is-not-correct'
})

extend('iban', {
  validate(value) {
    return /^[A-Z]{2}\d{13,32}$/i.test(value)
  },
  message: 'validations.neres_iban'
})

extend('isIbanUniq', {
  params: ['accounts'],
  validate: (value, { accounts }) => !accounts.includes(value),
  message:
    'validations.iban_is_not_unique'
})

extend('passport_numeric', {
  ...numeric,
  message: 'validations.passport_numeric'
})

extend('ua_address', {
  validate(value) {
    return /^[0-9а-щьюяґєії .,() \/ '`ʼ’‘—–−-]*$/gi.test(value)
  },
  message: 'validations.ua_address'
})

